<script>
    export let detail;

    const answer = [];
</script>

<div class="desktop">
    {#each detail as data, i}
        <div class="faq-div">
            <div
                class="faq-heading"
                on:click={() => {
                    if (answer[i] === true) {
                        answer[i] = false;
                    } else {
                        answer[i] = true;
                    }
                    console.log(answer[i]);
                }}
            >
                <div style="margin-left: 1.124vw; margin-top:1.389vw;">
                    <p
                        style="font-size: 1.190vw; font-weight:400; color:#00204B;"
                    >
                        {#if answer[i] != true}
                            <span> + </span>
                        {:else if (answer[i] = true)}
                            <span> - </span>
                        {/if}
                    </p>
                </div>
                <div style="margin-left: 2.187vw; margin-top:1.389vw;">
                    <p
                        style="font-size: 1.190vw; font-weight:400; color:#00204B;"
                    >
                        {data.heading}
                    </p>
                </div>
            </div>
            {#if answer[i] === true}
                <div class="faq-text">
                    <p
                        style="font-size: 1.190vw; font-weight:300; color:#00204B;
                        width:57.606vw;
                        margin-top:1.257vw;margin-left:3.307vw;"
                    >
                        {data.text}
                    </p>
                </div>
            {/if}
        </div>
    {/each}
</div>

<style>
    .faq-div {
        width: 65.608vw;
        margin: auto;
        margin-top: 1.852vw;
    }
    .faq-heading {
        background-color: #d1e4fd;
        border-radius: 0.8vw 0.8vw 0vw 0vw;
        display: flex;
        cursor: pointer;
    }
    .faq-text {
        border-radius: 0vw 0vw 0.8vw 0.8vw;
        border: 0.033vw solid #79adf4;
    }
</style>
